import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { downloadGeneratedPdfs, downloadGeneratedPdf } from "../../../services/fileDownloader";
import * as pdfActions from "../../../actions/pdfAction";
import { LoadingBar } from "../../../components/LoadingComponents/LoadingBar";
import * as documentActions from "../../../actions/documentActions";
import moment from "moment";
import * as pdfService from "../../../services/pdfService";
import "../../../styles/dispatch.scss";
import { toast } from "react-toastify";
import { LabelledCheckbox } from "../../../components/FormComponents/Checkbox";
import { getAllPdfsForGivenCustomerId } from "../../../actions/pdfAction";
import { PdfIcon } from "../../../components/Icons/PdfIcon";
import { CTA } from "@coverme/forms";

const isLoading = a => a.isInitialized === false || a.isLoading === true;

const DocumentItem = ({ fileName, id, isChecked, onChange, printDate = "Not Printed", onDownload }) => {
    const onChangeInternal = x => {
        const event = {
            [id]: x.target.checked,
        };
        onChange(event);
    };

    return (
        <div className="customer-document-item" key={id}>
            <LabelledCheckbox
                groupName={id}
                id={id}
                value={id}
                checked={isChecked}
                labelText={
                    <div className="customer-document-item-body">
                        <div style={{ width: "5%" }}>
                            <PdfIcon />
                        </div>
                        <div style={{ width: "70%" }}>
                            <p>{fileName}</p>
                        </div>
                        <div style={{ width: "50%" }}>
                            <h3>{printDate}</h3>
                        </div>
                        <div style={{ width: "10%" }}>
                            <CTA
                                className="download-btn"
                                styleType="blue"
                                ctaType="button"
                                size="small"
                                loading={false}
                                click={onDownload?.bind(this, id, fileName)}
                            >
                                fill
                            </CTA>
                        </div>
                    </div>
                }
                onChange={onChangeInternal}
                customWidth={"100%"}
            />
        </div>
    );
};

export const InterviewFormsAndApplicationsRepository = ({
    customerCode,
    encounterId,
    pdfList,
    getPdfs,
    interview,
    programs,
    customerJurisdictions,
    printedPdfList,
    customerId,
    getAllPdfsForGivenCustomerId,
    history,
    customerName,
}) => {
    const [checkedCards, setCheckedCards] = useState({});
    const [isDownloadingSubmitting, setIsDownloadingSubmitting] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(true);

    useEffect(() => {
        getAllPdfsForGivenCustomerId(customerId, [], encounterId);
    }, [customerId, printedPdfList]);

    useEffect(() => {
        getPdfs([], customerCode, encounterId, customerId, new Date(interview?.created), []);
    }, [pdfList, printedPdfList]);

    const formattedPdfList = useMemo(() => {
        const removeYearsFromFederal = /20[0-9]{2} Federal/;
        let formattedList = pdfList.data?.map(x => {
            return {
                ...x,
                name: x.name.replace(".pdf", "").replace(removeYearsFromFederal, "Federal"),
            };
        });

        return formattedList?.filter(x => x.isRequiredForACase === true);
    }, [pdfList, printedPdfList]);

    function onDownload(id, fileName) {
        downloadGeneratedPdf(encounterId, id, fileName, false)
            .then(() => {
                toast.info("Form is downloaded successfully");
                const selectedCategoriesObj = programs.data.filter(
                    x =>
                        x.eligibilityDeterminationStatus.name === "Action Complete" &&
                        x.eligibilityStatus.name === "Approved"
                );
                let selectedCategories = pdfService.getSelectedCategories(programs, interview);
                let jurisdictions = pdfService.getJurisdiction(selectedCategoriesObj, customerJurisdictions);
                getPdfs(
                    selectedCategories,
                    customerCode,
                    encounterId,
                    customerId,
                    new Date(interview.created),
                    jurisdictions
                );
            })
            .catch(() => {
                toast.error("There was an error downloading your forms, Please try again later");
            });
    }

    const onSelectedPdfsUpdated = item => {
        setCheckedCards({
            ...checkedCards,
            ...item,
        });
    };

    const onSelectAllChanged = () => {
        setIsSelectAllChecked(!isSelectAllChecked);
        var selectAllValue = isSelectAllChecked ? false : true;
        if (pdfList.data?.length > 0) {
            var checkedCards;
            pdfList.data.forEach(x => {
                var item = { [x.key]: selectAllValue };
                checkedCards = {
                    ...checkedCards,
                    ...item,
                };
            });
            setCheckedCards(checkedCards);
        }
    };
    const getSelectedPdfs = () => {
        if (pdfList.data?.length > 0) {
            let selectedPdfs = [];

            for (const pdf of pdfList.data) {
                if (checkedCards[pdf.key] !== false) {
                    selectedPdfs.push(pdf);
                }
            }
            return selectedPdfs;
        }
    };
    useEffect(() => {
        let selectedPdfs = getSelectedPdfs();
        if (pdfList.data?.length > 0) {
            selectedPdfs?.length == formattedPdfList?.length
                ? setIsSelectAllChecked(true)
                : setIsSelectAllChecked(false);
        }
    }, [checkedCards]);

    const onSubmit = mode => {
        setIsDownloadingSubmitting(true);
        if (pdfList.data?.length === 0) {
            history.push("/");
            return;
        }
        let pdfsToGenerate = getSelectedPdfs();
        pdfsToGenerate = pdfsToGenerate.map(x => x.key);
        if (mode === "print") {
            downloadGeneratedPdfs(encounterId, pdfsToGenerate, "GeneratePdf.pdf", false)
                .then(() => {
                    toast.info("Forms are downloaded successfully");
                    setIsDownloadingSubmitting(false);
                    const selectedCategoriesObj = programs.data.filter(
                        x =>
                            x.eligibilityDeterminationStatus.name === "Action Complete" &&
                            x.eligibilityStatus.name === "Approved"
                    );
                    let selectedCategories = pdfService.getSelectedCategories(programs, interview);
                    let jurisdictions = pdfService.getJurisdiction(selectedCategoriesObj, customerJurisdictions);
                    getPdfs(
                        selectedCategories,
                        customerCode,
                        encounterId,
                        customerId,
                        new Date(interview.created),
                        jurisdictions
                    );
                })
                .catch(() => {
                    setIsDownloadingSubmitting(false);
                    toast.error("There was an error downloading your forms, Please try again later");
                });
        }
    };

    return (
        <div className="document-repository-page">
            <LoadingBar isLoading={isLoading(pdfList)}>
                <div className="page-body">
                    <h2 className="title">Forms & Applications</h2>
                    <p> Below are the documents available to {customerName}.</p>
                    <div style={{ width: "100%", display: "flex" }}>
                        <div style={{ width: "65%" }}>
                            {pdfList.data?.length !== 0 && (
                                <LabelledCheckbox
                                    labelText={isSelectAllChecked ? `Select None` : `Select All`}
                                    id={`selectAllCkBox`}
                                    value={`selectAllCkBox`}
                                    checked={isSelectAllChecked}
                                    groupName="selectAllCkBox"
                                    onChange={onSelectAllChanged}
                                />
                            )}
                        </div>
                        <div style={{ width: "40%" }}>
                            <h3>Print Date</h3>
                        </div>
                        <div style={{ width: "10%" }}>
                            <h3>Action</h3>
                        </div>
                    </div>
                    {pdfList.data?.length === 0 && (
                        <div style={{ marginLeft: "30px" }}>
                            <p>No documents found.</p>
                        </div>
                    )}
                    <div className="document-group">
                        {formattedPdfList?.map(x => (
                            <DocumentItem
                                encounterId={encounterId}
                                key={x.key}
                                fileName={x.name}
                                isChecked={checkedCards[x.key] == null ? true : checkedCards[x.key]}
                                id={x.key}
                                onChange={onSelectedPdfsUpdated}
                                onDownload={onDownload}
                                printDate={
                                    printedPdfList?.filter(y => y.templateKey === x.key)[0]?.printDate
                                        ? moment(
                                              printedPdfList?.filter(y => y.templateKey === x.key)[0]?.printDate
                                          ).format("MM.DD.YYYY")
                                        : "Not Printed"
                                }
                            />
                        ))}
                    </div>
                    {pdfList.data?.length > 0 && (
                        <div className="wizard-buttons">
                            <CTA
                                size={"large"}
                                ctaType={"button"}
                                styleType={"grey-dark-alt"}
                                click={() => history.go(-1)}
                            >
                                &laquo; Back
                            </CTA>
                            <CTA
                                styleType="blue"
                                ctaType="button"
                                size="large"
                                loading={isDownloadingSubmitting}
                                disabled={getSelectedPdfs().length > 1 ? false : true}
                                click={onSubmit.bind(this, "print")}
                            >
                                Fill
                            </CTA>
                        </div>
                    )}
                </div>
            </LoadingBar>
        </div>
    );
};

export const InterviewFormsAndApplicationsContainer = connect(
    (state, ownProps) => {
        return {
            programs: state.programs,
            customerCode: state.customer.data?.customer?.code,
            customerId: state.customer.data?.customer?.GlobalId,
            pdfList: state.pdfsForCustomer,
            printedPdfList: state.pdfsForCustomer.data.generatedPdfsForEncounter,
            interview: state.interview,
            encounterId: ownProps.match.params.encounterId,
            customerJurisdictions: state.customer?.data?.jurisdictions,
            customerName: state.customer.data?.customer?.name,
        };
    },
    dispatch => ({
        getPdfs: (assistanceCategories, customerCode, encounterId, customerId, asOf, jurisdiction) =>
            dispatch(pdfActions.getPdfList(assistanceCategories, encounterId, customerId, asOf, jurisdiction)),
        resetPdfs: () => dispatch(pdfActions.resetPdfs()),
        getDocuments: (customerId, personId) => dispatch(documentActions.getDocuments(customerId, personId)),
        getAllPdfsForGivenCustomerId: (customerId, jurisdictions, encounterId) =>
            dispatch(getAllPdfsForGivenCustomerId(customerId, jurisdictions, encounterId)),
    })
)(InterviewFormsAndApplicationsRepository);
